<template>
  <div class="steps-outer">
    <div style="display: flex;width: 100%;">
      <div class="steps-container">
        <div class="steps-index" :class="{'active-steps': activeSteps === 1, 'completed-steps': activeSteps === 2 || activeSteps === 3}">1</div>
        <div style="margin-left: 5px;" :style="{color: activeSteps === 1 ? '#0db35b' : '#333'}">{{ $t('basicData.UploadTheFile') }}</div>
      </div>
      <div class="steps-line">
        <hr class="steps-line-hr">
      </div>
      <div class="steps-container">
        <div class="steps-index" :class="{'active-steps': activeSteps === 2, 'completed-steps': activeSteps === 3, 'notStarted-steps': activeSteps === 1}">2</div>
        <div style="margin-left: 5px;" :style="{color: activeSteps === 2 ? '#0db35b' : activeSteps === 1 ? '#a1a1a1' : '#333'}">{{ $t('userManage.dataValidation') }}</div>
      </div>
      <div class="steps-line">
        <hr class="steps-line-hr">
      </div>
      <div class="steps-container">
        <div class="steps-index" :class="{'active-steps': activeSteps === 3, 'notStarted-steps': activeSteps === 1 || activeSteps === 2}">3</div>
        <div style="margin-left: 5px;" :style="{color: activeSteps === 3 ? '#0db35b' : '#a1a1a1'}">{{ $t('userManage.CreationCompleted') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Steps',
  props: {
    activeSteps: {
      type: Number,
      default: 1
    }
  }
};
</script>

<style scoped>
.steps-line-hr {
  border: none;
  border-top: 1px solid #ccc;
  margin: 0;width: 100%;
}
.steps-line {
  flex: 1;
  display:flex;
  align-items: center;
  justify-content: center;
}
.steps-outer {
  display: flex;
  align-items: center;
  width: 100%;
}
.steps-container {
  padding: 0 5px;
  display: flex;
  font-size: 13px;
  align-items: center;
  justify-content: center;
}
.steps-index {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.active-steps {
  background: #0db35b;
  color: #fff;
  border-radius: 50%;
}
.completed-steps {
  background: #eaf8f0;
  color: #0db35b;
  border-radius: 50%;
}
.notStarted-steps {
  background: #e9edf2;
  color: #a1a1a1;
  border-radius: 50%;
}
</style>
